import LessonFormModal from "./LessonFormModal"

export function EditLessonModal({ closeModal, lessonData }) {
	return <LessonFormModal mode="edit" closeModal={closeModal} lessonData={lessonData} />
}

export default EditLessonModal
